

window.addEventListener("trix-file-accept", function (event) {
  // Allow attachments ONLY on blog pages
  const isBlog = document.querySelector(".blog") !== null

  if (!isBlog) {
    event.preventDefault()
    return
  }

  // Blog-only size limit (5 MB)
  const maxFileSize = 5 * 1024 * 1024

  if (event.file.size > maxFileSize) {
    event.preventDefault()
    alert("Sorry, blog attachments are limited to 5 MB.")
  }
})




//window.addEventListener("trix-file-accept", function (event) {
 // const acceptedTypes = ["image/jpeg", "image/png"];
 // if (!acceptedTypes.includes(event.file.type)) {
 //   event.preventDefault();
 //   alert("Sorry!  Cropper only supports attaching of jpeg or png files");
//  }
// });
